import React from 'react';
import { productName, logoSrc, logoStyleChrome } from '../../brand';
import PricingConfigS3Banner from '../PricingConfigS3Banner';
import PageFooter from './PageFooter';
import ProfileMenu from './ProfileMenu';

// AppShell wraps authenticated views. Top nav sits above page content;
// PageFooter (copyright + legal links) is always rendered below <main>.
export default function AppShell({
  user,
  pricingCatalog = null,
  onSignOut,
  navItems = [],
  footerBottomInset = 0,
  onShowMethodology,
  accountPrefsOpen = false,
  onAccountPrefsOpenChange,
  onProfileSettingsSaved,
  children,
}) {
  return (
    <div style={pageStyle}>
      <header style={topbarStyle}>
        <img src={logoSrc} alt={productName} style={logoStyleChrome} />
        <nav style={navStyle} aria-label="Primary">
          {navItems.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={item.onClick}
              style={item.active ? navLinkActiveStyle : navLinkStyle}
            >
              {item.label}
              {item.active && <span style={navActiveUnderlineStyle} aria-hidden="true" />}
            </button>
          ))}
        </nav>
        <div style={rightStyle}>
          {user && (
            <ProfileMenu
              user={user}
              onSignOut={onSignOut}
              preferencesOpen={accountPrefsOpen}
              onPreferencesOpenChange={onAccountPrefsOpenChange}
              onProfileSettingsSaved={onProfileSettingsSaved}
            />
          )}
        </div>
      </header>
      <PricingConfigS3Banner catalog={pricingCatalog} />
      <main>{children}</main>
      <PageFooter onShowMethodology={onShowMethodology} bottomInset={footerBottomInset} />
    </div>
  );
}

const pageStyle = { minHeight: '100vh', background: 'var(--bg)', display: 'flex', flexDirection: 'column' };

const topbarStyle = {
  height: '76px',
  background: 'var(--bg)',
  borderBottom: '1px solid var(--line)',
  display: 'flex',
  alignItems: 'center',
  padding: '0 32px',
  gap: '32px',
  position: 'relative',
};

const navStyle = { display: 'flex', gap: '22px', marginLeft: '12px', flex: 1 };
const navLinkStyle = {
  position: 'relative',
  fontSize: '13.5px',
  color: 'var(--muted)',
  background: 'transparent',
  border: 'none',
  padding: '20px 0',
  cursor: 'pointer',
  fontFamily: 'var(--font)',
};
const navLinkActiveStyle = { ...navLinkStyle, color: 'var(--ink)', fontWeight: 500 };
const navActiveUnderlineStyle = {
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  height: '2px',
  background: 'var(--accent)',
};

const rightStyle = { marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '14px' };
